import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createStaticVNode("<div class=\"head\"><h1>智慧图书馆大数据分析平台</h1><div class=\"weather\"><span id=\"showTime\"></span><button id=\"login_btn\">登录</button><button id=\"loginExit_btn\">退出</button></div></div>", 1);
const _hoisted_2 = { class: "mainbox" };
const _hoisted_3 = { class: "clearfix" };
import borrowBook from '@/pages/data-left-top/ScreenLefTop.vue';
import classifyBook from '@/pages/data-center-left/ScreenCenterLeft.vue';
import classRank from '@/pages/data-bottom-left/ScreenBootomLeft.vue';
//中间一列
import dataBook from '@/pages/data-center-top/ScreenCenterTop.vue';
//右边一列
import publicize from '@/pages/data-right-top/ScreenRightTop.vue';
import announcement from '@/pages/data-right-center/ScreenRightCenter.vue';
import peopleRank from '@/pages/data-right-bottom/ScreenRightBottom.vue';
import windowResize from "@/utils/resize";
import { onMounted, onUnmounted } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Screen',
    setup(__props) {
        // 左边一列
        const { calcRate, windowDraw, unWindowDraw } = windowResize();
        onMounted(() => {
            // 监听浏览器窗口尺寸变化
            windowDraw();
            calcRate();
        });
        onUnmounted(() => {
            unWindowDraw();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("ul", _hoisted_3, [
                        _createElementVNode("li", null, [
                            _createVNode(borrowBook),
                            _createVNode(classifyBook),
                            _createVNode(classRank)
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(dataBook)
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(publicize),
                            _createVNode(announcement),
                            _createVNode(peopleRank)
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
